import {
    ATTENDANCE_TEXT,
    BUTTON,
    GRADE_SCHEMA,
    GRADED_TEXT, POLL_TEXT,
    POLL_TYPE,
    QUESTION_HEADER,
    UNGRADED_TEXT
} from "../../utils/constants";
import classes from "./ReleaseActivityPage.module.css";
import React, {useEffect, useRef, useState} from "react";
import {ReactComponent as INFO_ICON} from "../../images/gray_info_icon.svg";
import {ReactComponent as GRADE_ICON} from "../../images/links/active_gradebook_icon.svg";
import {ReactComponent as QUESTION_MARKER_ICON} from "../../images/question_marker_polygon_purple.svg";
import {ReactComponent as POINTS_ICON} from "../../images/weightage_purple.svg";
import {ReactComponent as POLL_ICON} from "./images/poll_purple_icon.svg";
import {ReactComponent as ATTENDANCE_ICON} from "./images/attendance_purple_icon.svg";
import {ReactComponent as GEOFENCE_ENABLED_ICON} from "./images/geofence_enbaled_purple_icon.svg";
import {ReactComponent as GEOFENCE_DISABLED_ICON} from "./images/geofence_disabled_purple_icon.svg";
import {findFirstOverflowParent, generateUUID} from "../../utils/helpers";
import useWindowDimensions from "../../hooks/useWindowDimensions";


export default function ViewActivityInfoIcon({pollData}) {
    let windowDimensions = useWindowDimensions();


    const {poll = {}, questions = []} = pollData;

    const {gradeSchema, pollType, geofence} = poll;

    const infoCardOpenTriggerRef = useRef();
    const [infoCardOpen, setInfoCardOpen] = useState(false);
    const [randomId, ] = useState(() => generateUUID());


    const btnStyle = {width: 130, height: 40, display: "flex", alignItems: "center", justifyContent: "center"};



    const setPosition = () => {
        let trigger = document.querySelector(`[data-yuja-info-trigger-id='${randomId}']`);
        let card = document.querySelector(`[data-yuja-info-card-id='${randomId}']`);

        if (!trigger || !card) {
            return;
        }


        let parent = findFirstOverflowParent(trigger);
        const {left: parentLeft } = parent.getBoundingClientRect();


        const {left, width, height, top, } = trigger.getBoundingClientRect();
        const {width: cardWidth,  } = card.getBoundingClientRect();
        if (left - cardWidth > parentLeft) { // left
            card.style.transform =  `translate(${Math.round(left + width - cardWidth)}px, ${top + height + 5}px)`;
        } else {
            card.style.transform =  `translate(${Math.round(left)}px, ${top + height + 5}px)`;
        }



    }


    // useEffect(() => {
    //     if (infoCardOpen) {
    //         document.addEventListener('scroll', setPosition, true);
    //         setPosition();
    //     }
    //
    //     return () => {
    //         document.removeEventListener('scroll', setPosition)
    //     };
    // }, [infoCardOpen, windowDimensions, randomId]);


    useEffect(() => {
        const handleGlobalClick = (event) => {
            let card = document.querySelector(`[data-yuja-info-card-id='${randomId}']`);
            let trigger = document.querySelector(`[data-yuja-info-trigger-id='${randomId}']`);
            if (infoCardOpen && (!card || !card.contains(event.target)) && (!trigger || !trigger.contains(event.target))) {
                setInfoCardOpen(false);
            }
        };

        if (infoCardOpen) {
            setPosition();
            document.addEventListener('click', handleGlobalClick, true);
        }
        return () => {
            document.removeEventListener('click', handleGlobalClick)
        };
    }, [infoCardOpen, windowDimensions]);


    return (
        <>
            <span
                tabIndex={0}
                role={BUTTON}
                ref={infoCardOpenTriggerRef}
                data-yuja-info-trigger-id={randomId}
                className={`${classes.icon} ${infoCardOpen ? classes.active : ""}`}
                onClick={() => setInfoCardOpen(!infoCardOpen)}
            >
                <INFO_ICON/>
            </span>

            <div
                data-yuja-info-card-id={randomId}
                className={classes.activityInfoCard}
                style={{visibility: infoCardOpen ? "visible" : "hidden"}}
            >

                <div className={classes.row}>
                    <span className={classes.iconWrapper} style={{marginRight: 7}}>
                        {pollType === POLL_TYPE.ATTENDANCE
                            ? <ATTENDANCE_ICON style={{width: 20, height: 20}}/>
                            : <POLL_ICON style={{width: 20, height: 20}}/>
                        }

                    </span>
                    {pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE_TEXT : POLL_TEXT}
                </div>

                {pollType === POLL_TYPE.MERGED_POLL &&
                    <div className={classes.row}>
                        <span className={classes.iconWrapper} style={{marginRight: 7}}>
                            <GRADE_ICON style={{width: 20, height: 20}}/>
                        </span>
                        {gradeSchema === GRADE_SCHEMA.GRADED.key ? GRADED_TEXT : UNGRADED_TEXT}
                    </div>
                }

                {pollType === POLL_TYPE.MERGED_POLL &&
                    <div className={classes.row}>
                        <span className={classes.iconWrapper} style={{marginRight: 7}}>
                            <QUESTION_MARKER_ICON style={{width: 20, height: 20}}/>
                        </span>
                        {questions.length} {QUESTION_HEADER}
                    </div>
                }

                {gradeSchema === GRADE_SCHEMA.GRADED.key && pollType !== POLL_TYPE.ATTENDANCE &&
                    <div className={classes.row}>
                        <span className={classes.iconWrapper} style={{marginRight: 7}}>
                            <POINTS_ICON/>
                        </span>
                        {questions
                            .map(q => q.hasOwnProperty("weightage") ? q.weightage : 0)
                            .reduce((accumulator, currentValue) => {
                                return accumulator + currentValue
                            }, 0)
                        } {"Total Points"}
                    </div>
                }

                {pollType === POLL_TYPE.ATTENDANCE &&
                    <div className={classes.row}>
                        <span className={classes.iconWrapper} style={{marginRight: 7}}>
                            {!!geofence && !!Object.entries(geofence).length
                                ? <GEOFENCE_ENABLED_ICON style={{width: 20, height: 20}}/>
                                : <GEOFENCE_DISABLED_ICON style={{width: 20, height: 20}}/>
                            }
                        </span>
                        {!!geofence && !!Object.entries(geofence).length ? "Geofence Enabled" : "Geofence Disabled"}
                    </div>
                }
            </div>
        </>
    );
}